import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { CollectionSweepQuoteReceipt } from "../../../../../components/CollectionSweepQuoteReceipt";
import { CollectionSweepReceiptFragment } from "./CollectionSweepReceipt.fragment";
export const CollectionSweepReceipt = t0 => {
  const $ = _c(5);
  const {
    maxAmountOfItems,
    quote: quoteKey
  } = t0;
  let t1;
  if ($[0] !== quoteKey) {
    t1 = readFragment(CollectionSweepReceiptFragment, quoteKey);
    $[0] = quoteKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const quote = t1;
  let t2;
  if ($[2] !== maxAmountOfItems || $[3] !== quote) {
    t2 = <CollectionSweepQuoteReceipt maxAmountOfItems={maxAmountOfItems} quote={quote} />;
    $[2] = maxAmountOfItems;
    $[3] = quote;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};